import React, { useState, useRef } from 'react';
import { Send, Check } from 'lucide-react';
import emailjs from '@emailjs/browser';
export const ContactForm = () => {
  const [formStatus, setFormStatus] = useState({
    submitted: false,
    submitting: false,
    error: false,
    errorMessage: ''
  });
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    interest: 'property-seeker',
    message: ''
  });
  const formRef = useRef(null);
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    setFormStatus({
      submitted: false,
      submitting: true,
      error: false,
      errorMessage: ''
    });
    // Send email using emailjs
    emailjs.sendForm('service_id',
    // Replace with your EmailJS service ID in production
    'template_id',
    // Replace with your EmailJS template ID in production
    formRef.current, 'public_key' // Replace with your EmailJS public key in production
    ).then(result => {
      console.log('Email sent successfully:', result.text);
      setFormStatus({
        submitted: true,
        submitting: false,
        error: false,
        errorMessage: ''
      });
      // Reset form data
      setFormData({
        name: '',
        email: '',
        phone: '',
        interest: 'property-seeker',
        message: ''
      });
    }).catch(error => {
      console.error('Failed to send email:', error.text);
      setFormStatus({
        submitted: false,
        submitting: false,
        error: true,
        errorMessage: 'Failed to send email. Please try again or contact us directly at mocanplanners@gmail.com'
      });
    });
  };
  return <section id="contact" className="py-24 relative overflow-hidden" data-id="element-62">
      <div className="absolute -top-40 left-20 w-[400px] h-[400px] gradient-circle opacity-20" data-id="element-63"></div>
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] gradient-circle opacity-20" data-id="element-64"></div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-65">
        <div className="max-w-6xl mx-auto" data-id="element-66">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-67">
            <div className="reveal" data-id="element-68">
              <div className="inline-block bg-glass px-4 py-1 rounded-full text-xs font-medium mb-6 text-[#00d4ff]" data-id="element-69">
                CONTACT US
              </div>
              <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-70">
                Ready to Experience the{' '}
                <span className="text-gradient" data-id="element-71">Future</span> of Real Estate?
              </h2>
              <p className="text-lg text-gray-300 mb-8" data-id="element-72">
                Book a demo or request a virtual tour today. Our team is ready
                to show you how MUNISVerse can transform your property
                experience.
              </p>
              <div className="bg-glass rounded-xl p-8 mb-8 neon-border" data-id="element-73">
                <h3 className="text-xl font-bold mb-4 text-gradient" data-id="element-74">
                  Visit Our VR Center
                </h3>
                <p className="text-gray-300 mb-4" data-id="element-75">
                  Experience our technology firsthand at our state-of-the-art VR
                  center in Lagos.
                </p>
                <div className="text-gray-300" data-id="element-76">
                  <p className="mb-2" data-id="element-77">15 Victoria Island Boulevard</p>
                  <p className="mb-2" data-id="element-78">Lagos, Nigeria</p>
                  <p className="mb-2" data-id="element-79">+234 903 705 9783</p>
                  <p data-id="element-80">info@munisverse.com</p>
                </div>
              </div>
              <div className="flex space-x-4" data-id="element-81">
                <a href="https://www.instagram.com/munis_verse?igsh=MTF2Z2xxY2swZjlocQ%3D%3D&utm_source=qr" className="text-[#00d4ff] hover:text-white transition-colors" data-id="element-82">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-83">
                    <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" data-id="element-84"></path>
                  </svg>
                </a>
                <a href="#" className="text-[#00d4ff] hover:text-white transition-colors" data-id="element-85">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-86">
                    <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" data-id="element-87"></path>
                  </svg>
                </a>
                <a href="https://www.linkedin.com/in/bukola-m-a87aa5213/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" className="text-[#00d4ff] hover:text-white transition-colors" data-id="element-88">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-89">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" data-id="element-90"></path>
                  </svg>
                </a>
              </div>
            </div>
            <div className="bg-glass rounded-xl p-8 neon-border reveal" data-id="element-91">
              {formStatus.submitted ? <div className="text-center py-12" data-id="element-92">
                  <div className="w-16 h-16 bg-[rgba(0,212,255,0.2)] rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-93">
                    <Check size={32} className="text-[#00d4ff]" data-id="element-94" />
                  </div>
                  <h3 className="text-2xl font-bold mb-4 text-gradient" data-id="element-95">
                    Thank You!
                  </h3>
                  <p className="text-gray-300" data-id="element-96">
                    Your message has been received. Our team will get back to
                    you shortly.
                  </p>
                </div> : <form ref={formRef} onSubmit={handleSubmit} data-id="element-97">
                  <h3 className="text-2xl font-bold mb-6 text-gradient" data-id="element-98">
                    Book a Demo
                  </h3>
                  {formStatus.error && <div className="bg-red-900/30 border border-red-500/50 text-white p-4 rounded-lg mb-6" data-id="element-99">
                      <p data-id="element-100">{formStatus.errorMessage}</p>
                    </div>}
                  <div className="grid gap-6 mb-6" data-id="element-101">
                    <div data-id="element-102">
                      <label htmlFor="name" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-103">
                        Full Name
                      </label>
                      <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="w-full px-4 py-3 rounded-lg bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] text-white focus:ring-2 focus:ring-[#00d4ff] focus:border-transparent transition-all duration-300" required data-id="element-104" />
                    </div>
                    <div data-id="element-105">
                      <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-106">
                        Email Address
                      </label>
                      <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full px-4 py-3 rounded-lg bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] text-white focus:ring-2 focus:ring-[#00d4ff] focus:border-transparent transition-all duration-300" required data-id="element-107" />
                    </div>
                    <div data-id="element-108">
                      <label htmlFor="phone" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-109">
                        Phone Number
                      </label>
                      <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 rounded-lg bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] text-white focus:ring-2 focus:ring-[#00d4ff] focus:border-transparent transition-all duration-300" data-id="element-110" />
                    </div>
                    <div data-id="element-111">
                      <label htmlFor="interest" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-112">
                        I am a:
                      </label>
                      <select id="interest" name="interest" value={formData.interest} onChange={handleChange} className="w-full px-4 py-3 rounded-lg bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] text-white focus:ring-2 focus:ring-[#00d4ff] focus:border-transparent transition-all duration-300" data-id="element-113">
                        <option value="property-seeker" data-id="element-114">Property Seeker</option>
                        <option value="developer" data-id="element-115">Property Developer</option>
                        <option value="agent" data-id="element-116">Real Estate Agent</option>
                        <option value="investor" data-id="element-117">Investor</option>
                        <option value="other" data-id="element-118">Other</option>
                      </select>
                    </div>
                    <div data-id="element-119">
                      <label htmlFor="message" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-120">
                        Message
                      </label>
                      <textarea id="message" name="message" value={formData.message} onChange={handleChange} rows={4} className="w-full px-4 py-3 rounded-lg bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] text-white focus:ring-2 focus:ring-[#00d4ff] focus:border-transparent transition-all duration-300" data-id="element-121"></textarea>
                    </div>
                    {/* Hidden field for recipient email */}
                    <input type="hidden" name="to_email" value="mocanplanners@gmail.com" data-id="element-122" />
                  </div>
                  <button type="submit" disabled={formStatus.submitting} className="w-full btn-gradient text-white py-3 px-6 rounded-lg transition-all duration-300 flex items-center justify-center" data-id="element-123">
                    {formStatus.submitting ? <span className="inline-flex items-center" data-id="element-124">
                        <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-125">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-126"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-127"></path>
                        </svg>
                        Submitting...
                      </span> : <span className="inline-flex items-center" data-id="element-128">
                        <Send size={18} className="mr-2" data-id="element-129" />
                        Book Your Demo
                      </span>}
                  </button>
                </form>}
            </div>
          </div>
        </div>
      </div>
    </section>;
};